// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1QISB","author":"Table_author__3lUwA","authorImage":"Table_authorImage__1mjLq","unreadRow":"Table_unreadRow__2a7j-"};